let isBottleRotating = false;

function createBottle(
  containerSelector,
  flavor,
  labelTextureUrl,
  flavourColor,
  delay
) {
  const container = document.querySelector(containerSelector);
  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(
    75,
    (container.clientWidth + 200) / (container.clientHeight + 200),
    0.1,
    50
  );
  camera.position.set(0, 5, 10); // Légèrement reculé pour mieux voir la scène
  camera.lookAt(0, 5, 0);

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setSize(container.clientWidth + 200, container.clientHeight + 200);
  renderer.setClearColor(0x000000, 0);
  renderer.setPixelRatio(window.devicePixelRatio);
  container.appendChild(renderer.domElement);

  // Éclairage
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.4); // Lumière douce réduite
  scene.add(ambientLight);

  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8); // Réduction de l'intensité
  directionalLight.position.set(10, 15, 10);
  directionalLight.shadow.mapSize.width = 1024;
  directionalLight.shadow.mapSize.height = 1024;
  scene.add(directionalLight);

  // Ajout d'une lumière secondaire pour réduire les ombres dures
  const secondaryLight = new THREE.PointLight(0xfff0d6, 0.3, 10); // Couleur chaude (lumière douce)
  secondaryLight.position.set(-10, 5, 10);
  scene.add(secondaryLight);

  // Bouteille
  const bottlePoints = [
    new THREE.Vector2(0, 0),
    new THREE.Vector2(1.8, 0),
    new THREE.Vector2(1.9, 0),
    new THREE.Vector2(2, 1),
    new THREE.Vector2(2, 5.1),
    new THREE.Vector2(1.6, 7.1),
    new THREE.Vector2(1.6, 7.4),
    new THREE.Vector2(1.7, 7.5),
    new THREE.Vector2(1.6, 7.6),
    new THREE.Vector2(1.6, 7.85),
    new THREE.Vector2(1.6, 8.5),
  ];
  const bottleGeometry = new THREE.LatheGeometry(bottlePoints, 64);
  const bottleMaterial = new THREE.MeshPhysicalMaterial({
    color: "#FAF2D9", // Couleur légèrement beige
    metalness: 0,
    roughness: 0,
    transmission: 0.4, // Transparence physique
    opacity: 0.9,
    ior: 1, // Indice de réfraction
    thickness: 0.3,
    clearcoat: 1, // Couche de vernis
    clearcoatRoughness: 0.05,
  });
  const bottle = new THREE.Mesh(bottleGeometry, bottleMaterial);
  // bottle.castShadow = false;
  // bottle.receiveShadow = false;

  // Contenu de la bouteille (saveur) avec couleur personnalisée
  const flavourPoints = [
    new THREE.Vector2(0, 0),
    new THREE.Vector2(1.85, 0),
    new THREE.Vector2(1.95, 1),
    new THREE.Vector2(1.95, 5.1),
    new THREE.Vector2(1.55, 7.1),
  ];
  const flavourGeometry = new THREE.LatheGeometry(flavourPoints, 64);
  const flavourMaterial = new THREE.MeshPhysicalMaterial({
    color: flavourColor, // Couleur de la saveur
    metalness: 0,
    roughness: 0.2,
    ior: 1,
    opacity: 0.9,
    transparent: false,
  });
  const flavour = new THREE.Mesh(flavourGeometry, flavourMaterial);
  // flavour.castShadow = false;
  // flavour.receiveShadow = false;
  flavour.name = "flavour"; // Nommer l'objet

  // Capsule
  const capPoints = [
    new THREE.Vector2(1.6, 0),
    new THREE.Vector2(1.7, 0),
    new THREE.Vector2(1.65, 0.7),
    new THREE.Vector2(1.6, 0.75),
    new THREE.Vector2(0, 0.75),
  ];
  const capGeometry = new THREE.LatheGeometry(capPoints, 32);
  const capMaterial = new THREE.MeshPhysicalMaterial({
    color: "#000000", // Capsule noire
    metalness: 0.3,
    roughness: 0.5,
  });
  const cap = new THREE.Mesh(capGeometry, capMaterial);
  cap.position.y = 7.85;
  // cap.castShadow = true;

  // Étiquette avec texture dynamique
  const labelTexture = new THREE.TextureLoader().load(labelTextureUrl);
  const labelGeometry = new THREE.CylinderGeometry(
    2.01,
    2.01,
    3.6,
    64,
    1,
    true
  );
  const labelMaterial = new THREE.MeshPhysicalMaterial({
    map: labelTexture,
    roughness: 2,
    transparent: true,
  });
  const label = new THREE.Mesh(labelGeometry, labelMaterial);
  label.position.y = 2.8;
  // label.castShadow = true;
  label.name = "label"; // Nommer l'objet

  function createArm(color) {
    const armGroup = new THREE.Group();

    // Partie supérieure du bras (biceps)
    const upperArmGeometry = new THREE.CylinderGeometry(0.5, 0.32, 1.5, 16);
    const upperArmMaterial = new THREE.MeshStandardMaterial({ color: color });
    const upperArm = new THREE.Mesh(upperArmGeometry, upperArmMaterial);
    upperArm.rotation.z = Math.PI / 2; // Rotation pour aligner horizontalement
    upperArm.name = "upperArm";
    armGroup.add(upperArm);

    // Partie inférieure du bras (avant-bras)
    const lowerArmGeometry = new THREE.CylinderGeometry(0.32, 0.3, 1.5, 16);
    const lowerArmMaterial = new THREE.MeshStandardMaterial({ color: color });
    const lowerArm = new THREE.Mesh(lowerArmGeometry, lowerArmMaterial);
    lowerArm.position.x = 1.4; // Positionner après le biceps
    lowerArm.position.y = 0.2;
    lowerArm.rotation.z = Math.PI / 2 + 0.3;
    lowerArm.name = "lowerArm";
    armGroup.add(lowerArm);

    // Poing (sphère pour simuler une main)
    const fistGeometry = new THREE.SphereGeometry(0.8, 16, 16);
    const fistMaterial = new THREE.MeshPhysicalMaterial({
      color: "#000000", // Capsule noire
      metalness: 0.1,
      roughness: 0.5,
    });
    const fist = new THREE.Mesh(fistGeometry, fistMaterial);
    fist.position.x = 2.5; // Position après l’avant-bras
    fist.position.y = 0.6;
    fist.rotation.z = Math.PI / 2 + 0.3;
    armGroup.add(fist);

    // Poing (sphère pour simuler une main)
    const thumbGeometry = new THREE.SphereGeometry(0.4, 16, 16);
    const thumbMaterial = new THREE.MeshPhysicalMaterial({
      color: "#000000", // Capsule noire
      metalness: 0.1,
      roughness: 0.5,
    });
    const thumb = new THREE.Mesh(thumbGeometry, thumbMaterial);
    thumb.position.x = 2.1; // Position après l’avant-bras
    thumb.position.y = 0.97;
    thumb.rotation.z = Math.PI / 2 - 0.8;
    armGroup.add(thumb);

    return armGroup;
  }

  const leftArm = createArm("#e0ac69"); // Rouge pour le bras gauche
  leftArm.rotation.y = Math.PI;
  leftArm.position.set(-2, 5, 0.5); // Positionner à gauche
  scene.add(leftArm);

  const rightArm = createArm("#e0ac69"); // Rouge pour le bras droit
  rightArm.position.set(2, 5, 0.5); // Positionner à droite
  scene.add(rightArm);

  leftArm.visible = false;
  rightArm.visible = false;

  leftArm.name = "leftArm";
  rightArm.name = "rightArm";

  bottle.add(leftArm);
  bottle.add(rightArm);

  function animateArms() {
    gsap.to(leftArm.rotation, {
      z: Math.PI / 4,
      duration: 0.5,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut",
    });

    gsap.to(rightArm.rotation, {
      z: Math.PI / 4,
      duration: 0.5,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut",
    });
  }

  animateArms();

  // Animation et rendu
  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
  }

  let mouseX = 0;
  let mouseY = 0; // Position relative Y de la souris
  let targetX = 0; // Position cible X pour la caméra
  let targetY = 0; // Position cible Y pour la caméra
  let isHovered = false;
  let shakeIntensity = 0.05;

  // Détecte le hover sur le canvas
  window.addEventListener("mousemove", (event) => {
    // Récupérer les dimensions de l'élément contenant (renderer.domElement ici)
    const rect = renderer.domElement.getBoundingClientRect();

    // Calculer la position de la souris par rapport à l'élément de rendu
    const mouse = {
      x: ((event.clientX - rect.left) / rect.width) * 2 - 1,
      y: -((event.clientY - rect.top) / rect.height) * 2 + 1,
    };
    mouseX = mouse.x; // -1 à 1 pour X
    mouseY = mouse.y; // -1 à 1 pour Y

    // Créer un raycaster pour détecter les intersections
    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, camera);

    // Vérifier si la souris intersecte un objet spécifique (par exemple, 'bottle')
    const intersects = raycaster.intersectObject(bottle);
    isHovered = intersects.length > 0;
  });

  let shakeAngle = 0;

  function animate() {
    requestAnimationFrame(animate);

    if (!isBottleRotating) {
      // Animation de zoom lissée
      if (isHovered) {
        // Zoom vers l'avant
        bottle.position.z += (1.5 - bottle.position.z) * 0.1;
        flavour.position.z += (1.5 - flavour.position.z) * 0.1;
        label.position.z += (1.5 - label.position.z) * 0.1;
        cap.position.z += (1.5 - cap.position.z) * 0.1;

        // Lumière plus intense
        directionalLight.intensity += (1 - directionalLight.intensity) * 0.1;
      } else {
        // Revenir à la position d'origine
        bottle.position.z += (0.9 - bottle.position.z) * 0.1;
        flavour.position.z += (0.9 - flavour.position.z) * 0.1;
        label.position.z += (0.9 - label.position.z) * 0.1;
        cap.position.z += (0.9 - cap.position.z) * 0.1;

        // Lumière moins intense
        directionalLight.intensity += (0.8 - directionalLight.intensity) * 0.1;
      }

      // Animation de secousse
      shakeAngle += 0.1;
      const offset = Math.sin(shakeAngle) * shakeIntensity;

      bottle.position.x += (offset - bottle.position.x) * 0.1;
      flavour.position.x += (offset - flavour.position.x) * 0.1;
      label.position.x += (offset - label.position.x) * 0.1;
      cap.position.x += (offset - cap.position.x) * 0.1;

      bottle.position.y += (offset - bottle.position.y) * 0.1;
      flavour.position.y += (offset - flavour.position.y) * 0.1;
      label.position.y += (2.8 + offset - label.position.y) * 0.1;
      cap.position.y += (7.85 + offset - cap.position.y) * 0.1;

      bottle.rotation.y = mouseX * Math.PI * 0.07;
      label.rotation.y = -4.8 + mouseX * Math.PI * 0.07;
      cap.rotation.y = mouseX * Math.PI * 0.07;

      // Gestion de la caméra
      targetX = mouseX * 1;
      targetY = mouseY * -1;

      camera.position.x += (targetX - camera.position.x) * 0.05;
      camera.position.y += (5 + targetY - camera.position.y) * 0.05;
      camera.lookAt(0, 5, 0);
    }
    renderer.render(scene, camera);
  }

  setTimeout(() => {
    animate();
  }, delay);

  function addDescription() {
    const tag = document.createElement("a");
    tag.setAttribute(
      "href",
      `/collections/spud-dust/products/${flavor.product}`
    );
    tag.classList.add("fyf__game--link");
    tag.innerHTML = flavor.desc;
    container.appendChild(tag);
  }

  addDescription();

  const bottleGroup = new THREE.Group();
  bottleGroup.add(bottle, flavour, label, cap, leftArm, rightArm);
  scene.add(bottleGroup);
  return bottleGroup;
}

// Index pour les saveurs affichées
let currentFlavors = [0, 1];
let nextFlavorIndex = 2;

// Création initiale des bouteilles
const leftBottle = createBottle(
  ".fyf__game--left",
  flavors[currentFlavors[0]],
  flavors[currentFlavors[0]].texture,
  flavors[currentFlavors[0]].color,
  0
);
const rightBottle = createBottle(
  ".fyf__game--right",
  flavors[currentFlavors[1]],
  flavors[currentFlavors[1]].texture,
  flavors[currentFlavors[1]].color,
  500
);

function updateBottle(bottleGroup, flavorIndex, dom, currentFlavors, next) {
  const content = document.querySelector(next + "> canvas");
  const parent = content.parentElement;

  function updateDescription() {
    const tag = parent.querySelector("a");
    gsap.to(tag, {
      duration: 0.5,
      rtl: true,
      text: flavors[flavorIndex].desc,
    });
    tag.setAttribute(
      "href",
      `/collections/spud-dust/products/${flavors[flavorIndex].product}`
    );
    const leftLink = document.querySelector(".fyf__game--left > a");
    const rightLink = document.querySelector(".fyf__game--right > a");
    leftLink.style.transition = "color .3s";
    rightLink.style.transition = "color .3s";
    leftLink.style.color = flavors[currentFlavors].textColor;
    rightLink.style.color = flavors[currentFlavors].textColor;
  }

  updateDescription();

  // Animer vers la gauche
  content.style.transform = "translateX(-100%)";

  // Revenir de la droite après un délai
  setTimeout(() => {
    content.style.transition = "none"; // Supprimer la transition pour replacer instantanément
    content.style.transform = "translateX(100%)";
    if (bottleGroup != null && flavorIndex != null) {
      const labelMaterial = bottleGroup.getObjectByName("label").material;
      new THREE.TextureLoader().load(
        flavors[flavorIndex].texture,
        (texture) => {
          labelMaterial.map = texture;
          labelMaterial.map.encoding = THREE.sRGBEncoding; // Correct gamma
          labelMaterial.needsUpdate = true;
        }
      );

      // Met à jour la couleur de la saveur
      const flavourMaterial = bottleGroup.getObjectByName("flavour").material;
      flavourMaterial.color.set(flavors[flavorIndex].color);
    }

    // Réappliquer la transition pour le retour au centre
    setTimeout(() => {
      content.style.transition = "transform 0.2s ease-in-out";
      content.style.transform = "translateX(0)";
    }, 50); // Court délai pour garantir le reflow
  }, 200);

  const overlay = document.querySelector(".fyf-overlay");
  const domRect = document.querySelector(dom).getBoundingClientRect();

  overlay.style.left = `${domRect.width / 2 + domRect.left}px`;
  overlay.style.top = `${domRect.height / 2 + domRect.top}px`;

  const currentColor = flavors[currentFlavors].color;

  document.querySelector("body").style.transition = "color 1s ease-out";
  document.querySelector(".logo-area").style.transition =
    "color 2s ease-out, border-color 1s ease-out";
  document.querySelector(".majortitle").style.transition = "color 1s ease-out";

  document.querySelector(".fyf__rules--title").innerHTML =
    "&nbsp; <br/>&nbsp; ";
  document.querySelector(".fyf__rules--rules").innerHTML = "";

  const list = [
    "Interesting choice..",
    "Tough already...",
    "Fair. But how about this?",
    "This one may stump you!",
    "Love it.",
  ];

  let lastElement = null;

  function getRandomElement() {
    let randomElement;

    do {
      randomElement = list[Math.floor(Math.random() * list.length)];
    } while (randomElement === lastElement); // Répète tant que c'est le même

    lastElement = randomElement; // Met à jour le dernier élément
    return randomElement;
  }

  gsap.to(document.querySelector(".majortitle"), {
    duration: 1,
    text: getRandomElement(),
  });

  setTimeout(() => {
    document.querySelector("#pageheader").style.backgroundColor = "transparent";
    overlay.style.backgroundColor = currentColor;
    overlay.style.transition = "all .5s ease-out";
    overlay.style.width = `200vw`;
    overlay.style.height = `200vh`;

    document.querySelector("body").style.color =
      flavors[currentFlavors].textColor;
    document.querySelector(".logo-area").style.color =
      flavors[currentFlavors].textColor;
    document.querySelector(".logo-area").style.borderColor =
      flavors[currentFlavors].textColor;
    document.querySelector(".majortitle").style.color =
      flavors[currentFlavors].textColor;
    document.querySelectorAll(".svg-logo path").forEach((element) => {
      element.setAttribute("fill", flavors[currentFlavors].textColor);
    });
  }, 50);

  setTimeout(() => {
    document.body.style.backgroundColor = currentColor;
    document.querySelector("#pageheader").style.backgroundColor = currentColor;
    overlay.style.transition = "all 0s";
    overlay.style.width = `0`;
    overlay.style.height = `0`;
  }, 400);
}

// Gestion des sélections
function selectFlavor(isLeftSelected) {
  const selectedFlavorIndex = isLeftSelected
    ? currentFlavors[0]
    : currentFlavors[1];
  console.log("Saveur sélectionnée :", flavors[selectedFlavorIndex].texture);

  if (nextFlavorIndex >= flavors.length) {
    // console.log("Jeu terminé. Gagnant :", flavors[selectedFlavorIndex].name);
    // Identifie la bouteille perdante
    const losingBottle = isLeftSelected ? rightBottle : leftBottle;
    const losingDiv = isLeftSelected ? ".fyf__game--right" : ".fyf__game--left";
    const winningBottle = isLeftSelected ? leftBottle : rightBottle;
    const winningDiv = isLeftSelected
      ? ".fyf__game--left"
      : ".fyf__game--right";

    document.querySelector(losingDiv).classList.add("fyf__game--remove");
    document.querySelector(".fyf__game--center").innerHTML = "";
    losingBottle.visible = false;
    document.querySelector(losingDiv).querySelector("a").style.display = "none";

    const overlay = document.querySelector(".fyf-overlay");

    overlay.style.left = `${window.width / 2}px`;
    overlay.style.top = `${window.height / 2}px`;

    const currentColor = flavors[selectedFlavorIndex].color;
    const textColor = flavors[selectedFlavorIndex].textColor;

    document.querySelector("body").style.transition = "color 0.5s ease-out";
    document.querySelector(".logo-area").style.transition =
      "color 0.5s ease-out, border-color 0.5s ease-out";
    document.querySelector(".majortitle").style.transition =
      "color 0.5s ease-out";

    gsap.to(document.querySelector(".majortitle"), {
      duration: 1,
      text: "We have a winner!",
    });

    winningBottle.getObjectByName("leftArm").visible = true;
    winningBottle.getObjectByName("rightArm").visible = true;
    document.querySelector(winningDiv).style.transform = "scale(1.8)";
    document.querySelector(winningDiv).style.marginTop = "-5vh";
    document.querySelector(winningDiv).style.pointerEvents = "none";

    let rotationSpeed = 1; // Vitesse de rotation
    let rotationAmplitude = Math.PI / 4; // Amplitude de la rotation (ex. : 45°)
    let time = 0; // Temps accumulé

    function animateBottleRotation() {
      isBottleRotating = true;
      requestAnimationFrame(animateBottleRotation);

      // Faire osciller la rotation sur Y
      time += 0.03; // Ajustez pour contrôler la vitesse
      winningBottle.rotation.y =
        Math.sin(time * rotationSpeed) * rotationAmplitude;
    }
    animateBottleRotation();

    function fetchWinnerProduct(handle, container) {
      // Conteneur où afficher le produit
      const productContainer = document.querySelector(container);
      // Requête à l'API Storefront
      fetch(`/products/${handle}.js`) // API JSON pour Shopify
        .then((response) => {
          if (!response.ok) {
            throw new Error("Produit introuvable");
          }
          return response.json();
        })
        .then((product) => {
          const productHTML = `
            <div class="winner-product">
              <a style="color: ${textColor}" href="${product.url}">
                <img src="${product.featured_image}" alt="${product.title}" />
                <p>${product.title}</p>
                <p>From £${product.price / 100}</p>
              </a>
              <form action="/cart/add" method="post" enctype="multipart/form-data">
                <input type="hidden" name="id" value="${
                  product.variants[0].id
                }">
                <button type="submit" style="background-color: ${textColor}; color: ${currentColor}" class="add-to-cart">Add to cart</button>
              </form>
            </div>
          `;
          productContainer.innerHTML = productHTML;
        })
        .catch((error) => {
          productContainer.innerHTML = `<p>${error.message}</p>`;
        });
    }

    fetchWinnerProduct(
      flavors[selectedFlavorIndex].product,
      ".winner-product-container"
    );
    fetchWinnerProduct(
      flavors[selectedFlavorIndex].crisp,
      ".winner-crisps-container"
    );
    // fetchWinnerProduct(
    //   flavors[selectedFlavorIndex].dunks,
    //   ".winner-dunks-container"
    // );

    Draw();

    setTimeout(() => {
      document.querySelector("#pageheader").style.backgroundColor =
        "transparent";
      overlay.style.backgroundColor = currentColor;
      overlay.style.transition = "all 1s ease-out";
      overlay.style.width = `200vw`;
      overlay.style.height = `200vh`;

      document.querySelector("body").style.color = textColor;
      document.querySelector(".logo-area").style.color = textColor;
      document.querySelector(".logo-area").style.borderColor = textColor;
      document.querySelector(".majortitle").style.color = textColor;
    }, 50);

    setTimeout(() => {
      document.body.style.backgroundColor = currentColor;
      document.querySelector("#pageheader").style.backgroundColor =
        currentColor;
      overlay.style.transition = "all 0s";
      overlay.style.width = `0`;
      overlay.style.height = `0`;
    }, 400);

    const p = document.querySelector(".product-wrapper").style;
    p.display = "block";

    setTimeout(() => {
      document.querySelectorAll(".add-to-cart").forEach((elem) => {
        elem.style.backgroundColor = textColor;
        elem.style.color = currentColor;
      });
      document.querySelectorAll(".product > a").forEach((elem) => {
        elem.style.color = textColor;
      });
      document.querySelector(".product-wrapper > a").style.color = textColor;
      document.querySelector(".product-wrapper > a").style.borderColor =
        textColor;

      const c = document.getElementById("canvas").style;
      const g = document.querySelector(".fyf__game").style;

      // document.querySelector(winningDiv).style.position = "absolute";

      // document.querySelector(winningDiv).style.marginBottom = "6vh";
      setTimeout(() => {
        document.querySelector(winningDiv).querySelector("a").style.display =
          "none";
        document.querySelector(".fyf").style.transform = "scale(0.2)";
        document.querySelector(".fyf").style.left = "35%";
        document.querySelector(".fyf").style.width = "30%";
        document.querySelector(".fyf").style.top = "-20vh";
        document.querySelector(".fyf").style.position = "absolute";
        c.display = "none";
        p.opacity = 1;
      }, 100);
      // c.display = "none";
      // g.opacity = 0;
      // g.transform = "scale(0.3)";
      // c.opacity = 0;
    }, 3500);

    return;
  }

  // Mettre à jour la bouteille non sélectionnée
  const unselectedIndex = isLeftSelected ? 1 : 0;
  updateBottle(
    isLeftSelected ? rightBottle : leftBottle,
    nextFlavorIndex,
    isLeftSelected ? ".fyf__game--left" : ".fyf__game--right",
    selectedFlavorIndex,
    isLeftSelected ? ".fyf__game--right" : ".fyf__game--left"
  );

  // Mettre à jour les indices des saveurs
  currentFlavors[unselectedIndex] = nextFlavorIndex;
  nextFlavorIndex++;
}

let W = window.innerWidth;
let H = window.innerHeight;
const canvas = document.getElementById("canvas");
const context = canvas.getContext("2d");
const maxConfettis = 50;
const particles = [];

const possibleColors = [
  "DodgerBlue",
  "OliveDrab",
  "Gold",
  "Pink",
  "SlateBlue",
  "LightBlue",
  "Gold",
  "Violet",
  "PaleGreen",
  "SteelBlue",
  "SandyBrown",
  "Chocolate",
  "Crimson",
];

function randomFromTo(from, to) {
  return Math.floor(Math.random() * (to - from + 1) + from);
}

function confettiParticle() {
  this.x = Math.random() * W; // x
  this.y = Math.random() * H - H; // y
  this.r = randomFromTo(11, 33); // radius
  this.d = Math.random() * maxConfettis + 11;
  this.color =
    possibleColors[Math.floor(Math.random() * possibleColors.length)];
  this.tilt = Math.floor(Math.random() * 33) - 11;
  this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
  this.tiltAngle = 0;

  this.draw = function () {
    context.beginPath();
    context.lineWidth = this.r / 2;
    context.strokeStyle = this.color;
    context.moveTo(this.x + this.tilt + this.r / 3, this.y);
    context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
    return context.stroke();
  };
}

function Draw() {
  const results = [];

  // Magical recursive functional love
  requestAnimationFrame(Draw);

  context.clearRect(0, 0, W, window.innerHeight);

  for (var i = 0; i < maxConfettis; i++) {
    results.push(particles[i].draw());
  }

  let particle = {};
  let remainingFlakes = 0;
  for (var i = 0; i < maxConfettis; i++) {
    particle = particles[i];

    particle.tiltAngle += particle.tiltAngleIncremental;
    particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2;
    particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

    if (particle.y <= H) remainingFlakes++;

    // If a confetti has fluttered out of view,
    // bring it back to above the viewport and let if re-fall.
    if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
      particle.x = Math.random() * W;
      particle.y = -30;
      particle.tilt = Math.floor(Math.random() * 10) - 20;
    }
  }

  return results;
}

window.addEventListener(
  "resize",
  function () {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  },
  false
);

canvas.width = W;
canvas.height = H;

// Push new confetti objects to `particles[]`
for (var i = 0; i < maxConfettis; i++) {
  particles.push(new confettiParticle());
}

// Ajout des événements pour simuler une sélection
document
  .querySelector(".fyf__game--left > canvas")
  .addEventListener("click", () => {
    selectFlavor(true);
  });
document
  .querySelector(".fyf__game--right > canvas")
  .addEventListener("click", () => {
    selectFlavor(false);
  });
